module.exports = __webpack_public_path__ + "img/28.9b296c91.jpg";